/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
==========================================================================================*/

export default [
  {
    url: "/user/trainee-details/view",
    name: "Trainee Details",
    slug: "trainee-details-view",
    icon: "UserIcon",
    i18n: "TraineeDetails"
  },
  // {
  //   url: "/user/coaching-experience/view",
  //   name: "Coaching Experience",
  //   slug: "coaching-experience-view",
  //   icon: "SmileIcon",
  //   i18n: "coachingExperiences"
  // },
  {
    url: "/user/training-center/view",
    name: "Training Center",
    slug: "training-center",
    icon: "HelpCircleIcon",
    i18n: "trainingCenter"
  },
  {
    url: "/user/trainee-list/view",
    name: "Trainee List",
    slug: "trainee-details-view",
    icon: "SmileIcon",
    i18n: "CoacheeList"
  },
  /*{
    url: "/user/switch-language",
    name: "Switch Language",
    slug: "coach-switch-languages",
    icon: "StarIcon"
    // i18n: "Switch Language"
  },*/

];
